export const state = () => ({
    cartSummaryData: null,
})

export const getters = {
    cartSummaryData: (state) => state.cartSummaryData,
}

export const mutations = {
    updateCartSummaryData(state, payload) {
        state.cartSummaryData = payload
    },
}
